<div [ngClass]="{'strikethrough':row.restored}" *ngIf="this.row.modified==NO_MODIFIED_CELL">
  <span class="pm-lr-2">{{value}}</span>
</div>
<div [ngClass]="{'error-cell-rend': true, 'strikethrough':row.restored}" *ngIf="this.row.modified==ERROR_MODIFIED_CELL">
  <span class="pderr-cell-rend pm-lr-2">{{value}}</span>
</div>
<div *ngIf="this.row.modified==MODIFIED_CELL;" [ngClass]="{'colorYellow':true, 'strikethrough':row.restored}">
  <span class="pderr-cell-rend pm-lr-2">{{value}}</span>
</div>
